import React from 'react';

// Misma paginacion que TableView, para listas que no usan la tabla.
export const POR_PAGINA = 10;

export const paginar = (lista, pagina) => lista.slice((pagina - 1) * POR_PAGINA, pagina * POR_PAGINA);

const Paginacion = ({ pagina, total, onCambiar }) => {
    const paginas = Math.max(1, Math.ceil(total / POR_PAGINA));
    if (total <= POR_PAGINA) return null;
    const mostrando = Math.min(POR_PAGINA, total - (pagina - 1) * POR_PAGINA);
    const botones = [
        { ir: 1, disabled: pagina <= 1, icon: '⟪', title: 'Primera página' },
        { ir: pagina - 1, disabled: pagina <= 1, icon: '‹', title: 'Anterior' },
        { ir: pagina + 1, disabled: pagina >= paginas, icon: '›', title: 'Siguiente' },
        { ir: paginas, disabled: pagina >= paginas, icon: '⟫', title: 'Última página' },
    ];
    return (
        <div className="px-5 py-4 flex flex-wrap items-center justify-between gap-3 bg-gradient-to-r from-white to-gray-50 border-t border-gray-100">
            <div className="flex items-center gap-2 bg-gray-100 px-3 py-1.5 rounded-lg">
                <span className="text-xs text-gray-500">Mostrando</span>
                <span className="text-sm font-bold text-sura-blue">{mostrando}</span>
                <span className="text-xs text-gray-500">de</span>
                <span className="text-sm font-bold text-gray-700">{total}</span>
            </div>
            <div className="flex items-center gap-4">
                <div className="flex items-center gap-2 text-sm">
                    <span className="text-gray-500">Página</span>
                    <span className="bg-sura-blue text-white px-2.5 py-1 rounded-lg font-bold text-xs">{pagina}</span>
                    <span className="text-gray-500">de</span>
                    <span className="font-semibold text-gray-700">{paginas}</span>
                </div>
                <div className="flex gap-1">
                    {botones.map(b => (
                        <button
                            key={b.title}
                            type="button"
                            onClick={() => onCambiar(b.ir)}
                            disabled={b.disabled}
                            title={b.title}
                            className={`w-9 h-9 flex items-center justify-center rounded-xl text-lg font-medium transition-colors duration-200 ${b.disabled
                                ? 'bg-gray-100 text-gray-300 cursor-not-allowed'
                                : 'bg-white border-2 border-gray-200 text-gray-600 hover:border-sura-blue hover:text-sura-blue'}`}
                        >
                            {b.icon}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Paginacion;
